/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        27/02/2020 11:51
 * @copyright   Copyright (c) 2002-2020 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import 'slick-carousel/slick/slick.min';
import 'jquery-match-height/dist/jquery.matchHeight-min';
import Ux from '../services/ux';

export default class WpetSingle {
    
    static #shift = 0;
    
    constructor()
    {
        WpetSingle.initializeTourism();
        WpetSingle.initializeSlick();
        WpetSingle.initializeDetail();
        WpetSingle.initializeAnchor();
        
        if ( window.matchMedia( "(max-width: 650px" ).matches ) {
            Ux.initializeSmoothScroll( 60 );
        }
    }
    
    static initializeTourism()
    {
        let jstoggleMap = $( '.js-toggleMap' );
        jstoggleMap.on( 'click', function ( e ) {
            e.preventDefault();
            $( '.wpetMobileMap' ).show();
            window.wpet_map_object.mapObject.resize();
        } );
        
        let jsCloseMap = $( '.js-wpetMobileMapClose' );
        jsCloseMap.on( 'click', function ( e ) {
            e.preventDefault();
            $( '.wpetMobileMap' ).hide();
        } );
        
        let strate       = document.querySelectorAll( '.wpetStrate' ),
            strateTitles = document.querySelectorAll( '.wpetStrateTitle' );
        
        strateTitles.forEach( strateTitle => strateTitle.addEventListener( 'click', ( e ) => {
            e.currentTarget.parentNode.classList.toggle( 'open' );
            e.currentTarget.classList.toggle( 'open' );
        } ) );
    }
    
    static initializeSlick()
    {
        //Slick table period
        let $wpetTable = $( '.wpetTableList' );
        if ( $wpetTable.length > 0 ) {
            $wpetTable.slick( {
                                  slide: '.wpetTableContainer',
                                  slidesToShow: 1,
                                  arrows: true,
                                  dots: false,
                                  infinite: false,
                              } );
        }
        
        // Slick gallery
        let $wpetGalleryItem = $( '.js-wpetGallery' );
        if ( $wpetGalleryItem.length > 0 ) {
            
            $wpetGalleryItem.slick( {
                                        slide: '.wpetGalleryItem',
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        speed: 1000,
                                        autoplaySpeed: 5000,
                                        arrows: true,
                                        dots: false,
                                        infinite: false
                                    } );
        }
    }
    
    static initializeDetail()
    {
        $( '.wpetStrate .wpetStrateTitle' ).on( 'click', function ( e ) {
            e.preventDefault();
            $( this ).parent().toggleClass( 'close' );
        } );
    }
    
    static initializeAnchor()
    {
        if ( $( '.single-wpet .anchor' ).length > 0 ) {
            WpetSingle.getIdActive( $( '.wpetStrate' ), $( '.anchor' ), $( '.anchorItem' ), WpetSingle.#shift );
        }
    }
    
    static getIdActive( partsItem, wrapperNav, navItem, shift )
    {
        shift = (typeof shift !== 'undefined') ? shift : 0;
        
        let itemOffset = {};
        let idActive   = '';
        
        $.each( partsItem, function () {
            
            itemOffset[ $( this ).attr( 'id' ) ] = $( this ).offset().top;
        } );
        
        $( window ).scroll( function () {
            
            for ( let id in itemOffset ) {
                
                if ( itemOffset[ id ] < (navItem.find( 'a[href="#' + id + '"]' ).offset().top + shift) ) {
                    
                    idActive = id;
                }
            }
            
            if ( '' != idActive ) {
                if ( itemOffset[ Object.keys( itemOffset )[ 0 ] ] > (navItem.find( 'a[href="#' + idActive + '"]' ).offset().top + shift) ) {
                    
                    navItem.find( 'a' ).removeClass( 'active' );
                    
                } else {
                    navItem.find( 'a' ).removeClass( 'active' );
                    navItem.find( 'a[href="#' + idActive + '"]' ).addClass( 'active' );
                }
            }
            
        } );
    }
}
